import React from "react";
import Execution from "./Execution";

const BaseMarketMaking: React.FC = () => (
  <div className="p-6 flex flex-col gap-5" dir="rtl">
    <h1 className="text-xl font-bold">بازارگردانی پایه</h1>
    <Execution />
  </div>
);

export default BaseMarketMaking;
